export function resolveAudience() {
  try {
    const url = new URL(window.location.href);
    const qp = (url.searchParams.get('audience') || '').toLowerCase();
    if (qp === 'coach' || qp === 'client') return qp;
    const h = window.location.hostname || '';
    if (h.includes('mentormind')) return 'client';
    return 'client';
  } catch (_) {
    return 'client';
  }
}


